<template>
  <a class="c-headerLogo" tabindex="0" :href="url ? url : redirectMainRoute" :class="flat ? 'c-headerLogo--flat' : ''">
    <picture class="c-headerLogo_image" :class="imageStyle" alt="CoteiBem" title="Ir para página inicial">
      <source v-if="isDarkMode && !businessMode  && !flat" :srcset="require('icon/custom/logo-color-white-horizontal.svg')">
      <source v-if="!isDarkMode && !businessMode && !flat" :srcset="require('icon/custom/logo-color-dark-horizontal.svg')">
      <source v-if="businessMode  && !flat" :srcset="require('icon/custom/logo-business-color-light-horizontal.svg')">
      <source v-if="!isDarkMode && !businessMode && flat"  :srcset="require('icon/custom/logo-flat.svg')">
      <source v-if="flat" :srcset="require('icon/custom/logo-flat.svg')">
      <img class="c-headerLogo_image" :class="imageStyle" :src="require('icon/custom/logo-color-mono.svg')" width="180" height="40" alt="Logo do Coteibem" title="Ir para página inicial">
    </picture>
  </a>
</template>

<script>
import { mapState } from 'vuex'
import { landing, account } from 'routes'

const initialState = () => ({})

export default {
  props: {
    largeMode: {
      type: Boolean,
      default: false,
      required: false,
    },
    darkMode: {
      type: Boolean,
      required: false,
    },
    flat: {
      type: Boolean,
      required: false,
      default: false,

    },
    businessMode: {
      type: Boolean,
      default: false,
      required: false,
    },
    url: {
      type: String,
      default: null,
      required: false,
    }
  },

  data() {
    return initialState()
  },

  computed: {
    ...mapState({
      isAuthenticated: state => state.account.authenticated,
      isCompanyActive: state => state.account.company.isActive,
    }),

    redirectMainRoute() {
      return this.isAuthenticated
        ? account.redirect
        : landing.index
    },

    isDarkMode() {
      return this.isAuthenticated
        && this.isCompanyActive || this.darkMode
    },

    imageStyle() {
      return this.largeMode
        ? 'c-headerLogo_image--largeMode'
        : ''
    },
  },

  methods: {}
}
</script>

<style lang="scss">
@import "~css/_references";
@import '~css/Modules/menu';

.c-headerLogo {
  @extend .m-menuHeader_link;
  flex-grow: 0;
  min-width: 60px;
  min-height: 60px;
  box-sizing: border-box;
  padding-left: $v-gap-sm;

  @media (min-width: $v-screen-container + $v-gap-mdl) {
    padding-left: $v-gap-sml;
  }

  &--flat {
    padding-left: 0;
  }

  @include f-media('>=tablet') {
    &:hover { background-color: transparent; }
  }

  @include f-media('>=desktop') {
    min-height: 70px;
    border: none;

    &::after {
      margin: auto 0 auto $v-gap-xxs;
      position: relative;
      top: 2px;
    }
  }

  &_image {
    width: auto;
    height: 24px;

    @include f-media('>=tablet') {
      height: 40px;
    }

    &--largeMode {
      height: 35px;

      @include f-media('>=desktop') { height: 58px; }
    }
  }

  &_snet {
    width: auto;
    height: 30px;
    margin-left: $v-gap-sm;
    padding-left: $v-gap-sm;
    border-left: 1px solid $v-colorGray-light-2;

    &--darkMode {
      border-color: $v-colorGray-dark-4;
    }

    @include f-media('<desktopMedium') {
      display: none;
    }
  }
}
</style>